import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
//   _token= sessionStorage.getItem('token');  
//   allowed_keyCodes={
//     'number':[35,37,39,46]
//   }
  previousStep:boolean= false;
  showWelcomeBanner:any;
  isLoadedOnIframe: any;
  clinicList:any;
 // base_url: string = 'http://localhost:56485/';
  /**
   * allowedNumberKeyCodes function is to get the valid special keycodes for number type field (ZipCode)
   */
//   get allowedNumberKeyCodes(){
//     return this.allowed_keyCodes.number;
//   }

   checkParentComponent(){
    if (window.self !== window.top)
      this.isLoadedOnIframe = true;
    else
      this.isLoadedOnIframe = false;
  }

  constructor(private http:HttpClient) { }
  getRequest(url:any){
    //https://abs-vaccine-mgmt-dev.crm.dynamics.com/api/data/v9.2/aci_zipcodes?$select=aci_zipcodeid,_aci_division_value,_aci_state_value,aci_name,_aci_countyid_value,aci_primarycity&$expand=aci_Division($select=aci_divisionid,aci_divisonname),aci_state($select=aci_name,aci_stateid)&$filter=(contains(aci_name, '123')) and (aci_Division/aci_divisionid ne null) and (aci_state/aci_stateid ne null)&$top=100
    //url = this.base_url+url;
   // environment
   console.log('base_url is'+ environment.base_url);
   
    url = environment.base_url+url;
    return this.http.get<any>(url);

  }
  postRequest(url:any,postParams:any,headerObj:any={}){
   // url = this.base_url+url;
   console.log('base_url is'+ environment.base_url);
    url = environment.base_url+url;
    return this.http.post<any>(url,postParams);
  }

  postRequestPromise(url:any,postParams:any,headerObj:any={}){
    //url = this.base_url+url;
    url = environment.base_url+url;
    return firstValueFrom(this.http.post<any>(url,postParams));
  }
//   postRequestPromise(url:any,postParams:any,headerObj:any={}){
//     url = environment.base_url+url;
//     return this.http.post<any>(url,postParams).toPromise();
//   }
//   patchRequest(url:any,postParams:any,headerObj:any){
//     url = environment.base_url+url;
//     return this.http.patch<any>(url,postParams);
//   }
//   getLead(leadId:string){
//     let url = environment.base_url + "leads("+leadId+")";
    
//     let customHeaders= new HttpHeaders()
//                   .set('content-type', 'application/json; charset=utf-8')
//                   .set('OData-MaxVersion',' 4.0')
//                   .set('OData-Version','4.0')
//                   .set('Accept','application/json')
//                   .set('Access-Control-Allow-Origin', '*')
//                   .set('Authorization','Bearer ' + this._token);
//     let httpOptions = {
//       headers:customHeaders
//     };
//     return this.http.get<any>(url,httpOptions);
 
//   }
//   scrollToPosition(firstInvalidControl:any){
//     let topValue=this.getTopOffset(firstInvalidControl);
//     window.scroll({
//       top: topValue,
//       left: 0,
//       behavior: "smooth"
//     });
//     window.top?.postMessage({"type":"positionScroll",topValue}, '*');
//   }
//   getTopOffset(controlEl: HTMLElement): number {
//     const labelOffset = 50;
//     return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
//   }

scrollToPosition(firstInvalidControl:any){
  let topValue=this.getTopOffset(firstInvalidControl);
  window.scroll({
    top: topValue,
    left: 0,
    behavior: "smooth"
  });
  window.top?.postMessage({"type":"positionScroll",topValue}, '*');
}
getTopOffset(controlEl: HTMLElement): number {
  const labelOffset = 50;
  return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
}
}
